export const year = (new (Date)).getFullYear()
export const lastYear = year - 1
